var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 27,
    viewBox: "0 0 31 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.51221 2.30164C3.2317 2.30164 4.95513 2.08398 6.68769 2.08398C8.70465 2.08398 10.252 2.74654 12.0687 3.48669C14.7484 4.57842 17.4797 6.15845 18.8162 8.83146C19.8089 10.8169 19.8736 13.4156 20.1826 15.5789C20.614 18.5984 20.231 21.8673 20.231 24.9383",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 25C21.118 24.8175 21.2646 24.6449 21.4025 24.4762C21.8753 23.8975 22.3675 23.3314 22.882 22.7831C24.0517 21.5366 25.3276 20.3994 26.7445 19.3889C27.4628 18.8766 28.2206 18.4273 29 18",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 25C19.882 24.8175 19.7354 24.6449 19.5975 24.4762C19.1247 23.8975 18.6325 23.3314 18.118 22.7831C16.9483 21.5366 15.6724 20.3994 14.2555 19.3889C13.5372 18.8766 12.7794 18.4273 12 18",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubArrow);
export default __webpack_public_path__ + "static/media/sub-arrow.aeb6cd644da2e527179c008f72819932.svg";
export { ForwardRef as ReactComponent };